import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "footer",
  class: "container mx-auto py-24 pb-16 sm:py-32 sm:pb-24"
}
const _hoisted_2 = { class: "p-10 bg-muted/50 dark:bg-card border rounded-2xl" }
const _hoisted_3 = { class: "grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-x-12 gap-y-8" }
const _hoisted_4 = { class: "col-span-full xl:col-span-2" }
const _hoisted_5 = {
  href: "#",
  class: "flex font-bold items-center"
}

import { ChevronsDown } from "lucide-vue-next";
import Separator from "./ui/separator/Separator.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(ChevronsDown), { class: "bg-gradient-to-tr from-[#ff9500] via-[#ff9500]/70 to-[#ff9500] rounded-lg w-9 h-9 mr-2 border text-white" }),
            _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-2xl" }, "Autrement Capable", -1))
          ])
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"flex flex-col gap-2\"><h3 class=\"font-bold text-lg\">Parcours</h3><div><a href=\"#services\" class=\"opacity-60 hover:opacity-100\"> Parcours Jeune </a></div><div><a href=\"#services\" class=\"opacity-60 hover:opacity-100\"> Accompagnateur </a></div><div><a href=\"#services\" class=\"opacity-60 hover:opacity-100\"> Entreprise </a></div></div><div class=\"flex flex-col gap-2\"><h3 class=\"font-bold text-lg\">À propos</h3><div><a href=\"#benefits\" class=\"opacity-60 hover:opacity-100\"> Notre Mission </a></div><div><a href=\"#team\" class=\"opacity-60 hover:opacity-100\"> L&#39;Équipe </a></div><div><a href=\"#features\" class=\"opacity-60 hover:opacity-100\"> Fonctionnalités </a></div></div><div class=\"flex flex-col gap-2\"><h3 class=\"font-bold text-lg\">Aide</h3><div><a href=\"#contact\" class=\"opacity-60 hover:opacity-100\"> Contact </a></div><div><a href=\"#faq\" class=\"opacity-60 hover:opacity-100\"> FAQ </a></div><div><a href=\"#\" class=\"opacity-60 hover:opacity-100\"> Confidentialité </a></div></div><div class=\"flex flex-col gap-2\"><h3 class=\"font-bold text-lg\">Partenaires</h3><div><a href=\"#\" class=\"opacity-60 hover:opacity-100\"> Association Ikigai </a></div><div><a href=\"#\" class=\"opacity-60 hover:opacity-100\"> Psychologie TSA </a></div><div><a href=\"#\" class=\"opacity-60 hover:opacity-100\"> Inclusion Pro </a></div></div>", 4))
      ]),
      _createVNode(Separator, { class: "my-6" }),
      _cache[2] || (_cache[2] = _createElementVNode("section", { class: "" }, [
        _createElementVNode("h3", { class: "" }, " © 2025 Autrement Capable - Plateforme inclusive d'orientation professionnelle "),
        _createElementVNode("p", { class: "text-sm text-muted-foreground mt-2" }, " En partenariat avec l'association Ikigai et accompagné par une psychologue spécialisée en autisme ")
      ], -1))
    ])
  ]))
}
}

})